export const capitalize = (str) => {
  if (!str) return ''; // Return empty string if input is empty
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
